(function () {
  'use strict';
  if (customElements.get('hj-message-card')) return;
  class MessageCard extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-card-toggle]');
      this.input = this.querySelector('[data-card-input]');
      this.fields = this.querySelector('[data-card-fields]');
      this.error = this.querySelector('[data-card-error]');
      this.scope = this.closest('.hj-personalize-scope');
      this.available = this.dataset.available === 'true' && Number(this.dataset.variantId) > 0;
      this.toggle.disabled = !this.available;
      this.toggle.addEventListener('change', () => {
        this.render();
        this.changed();
      });
      this.input.addEventListener('input', () => { this.render(); this.changed(); });
      this.render();
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.validate(false));
        this.resize.observe(this.querySelector('[data-card-art]'));
      }
    }
    disconnectedCallback() {
      if (this.resize) this.resize.disconnect();
      this.ready = false;
    }
    message() { return this.input.value.replace(/\r\n?/g, '\n').trim(); }
    signature() { return JSON.stringify([this.toggle.checked, this.dataset.variantId, this.message()]); }
    price() { return this.toggle.checked && this.available ? Number(this.dataset.price) || 0 : 0; }
    validate(showError) {
      let error = '';
      const message = this.message();
      if (this.toggle.checked) {
        if (!this.available) error = 'This card is currently unavailable. Please uncheck it to continue.';
        else if (!message) error = 'Please enter your message for the card.';
        else if (message.length > Number(this.dataset.maxLength || 200)) error = 'Please shorten your message to fit the card.';
        else if (message.split('\n').length > 7) error = 'Please use no more than 7 lines.';
        else {
          const text = this.input;
          if (text.clientHeight && text.scrollHeight > text.clientHeight + 1) error = 'Your message is too tall for the card. Please shorten it or remove a line break.';
        }
      }
      this.input.setCustomValidity(error);
      this.input.setAttribute('aria-invalid', error && (showError || message) ? 'true' : 'false');
      this.error.textContent = error;
      this.error.hidden = !error || (!showError && !message);
      return error;
    }
    cartItem() {
      if (!this.toggle.checked) return null;
      const error = this.validate(true);
      if (error) { this.input.focus(); throw new Error(error); }
      return { id: Number(this.dataset.variantId), quantity: 1, properties: { Message: this.message() } };
    }
    setBusy(busy) {
      this.toggle.disabled = busy || !this.available;
      this.input.disabled = busy || !this.toggle.checked;
    }
    render() {
      this.fields.hidden = !this.toggle.checked;
      this.input.disabled = !this.toggle.checked;
      this.input.required = this.toggle.checked;
      this.querySelector('[data-card-count]').textContent = this.input.value.length + '/' + (this.dataset.maxLength || 200);
      this.validate(false);
    }
    changed() { this.dispatchEvent(new CustomEvent('havjoy:message-card-change', { bubbles: true })); }
  }
  customElements.define('hj-message-card', MessageCard);
})();
